import React, { useContext } from 'react';
import ControlButton from './ControlButton';
import { WatchesNotificationTypes } from 'types';
import { WatchFullInfoContext, IWatchFullInfoContext } from '../../../watchFullInfoState/watchFullInfoContext';
import style from './index.module.scss';

export const Controls: React.FC = () => {
	const { changeTypeOfModalWindow, setDataForPush, watchFullInfo } =
		useContext<IWatchFullInfoContext>(WatchFullInfoContext);

	const handlePush = (notificationType: WatchesNotificationTypes) => {
		if (watchFullInfo?.restaurantId && watchFullInfo.serialNumber) {
			changeTypeOfModalWindow('confirm');
			const { serialNumber, restaurantId } = watchFullInfo;
			setDataForPush({
				serialNumber,
				data: {
					restaurantId,
					notificationType,
				},
			});
		}
	};

	return (
		<div className={style.container} data-test="Controls">
			<div className={style.wrapper}>
				<ControlButton
					label="deactivateWatch"
					onClick={() => handlePush(WatchesNotificationTypes.PushDeactivateWatch)}
				/>
			</div>
		</div>
	);
};
